import { CircleCheckIcon, InfoIcon, Loader2Icon, OctagonXIcon, TriangleAlertIcon } from 'lucide-react';
import { Toaster as Sonner, type ToasterProps } from 'sonner';

/**
 * Design system §6: white, radius 12, md shadow, 14px/600 title + mono 11.5 detail,
 * teal 13px/600 action on the right.
 *
 * v1 is light only (§10), so the theme is hardcoded — shadcn's generated version reads it
 * from `next-themes`, which this app deliberately does not install.
 */
const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      toastOptions={{
        classNames: {
          toast: 'group rounded-xl border-border shadow-md',
          title: 'text-sm font-semibold text-ink',
          description: 'font-mono text-[11.5px] text-subtle',
          actionButton: 'text-[13px] font-semibold text-primary',
          success: '[&_[data-icon]]:text-success',
          warning: '[&_[data-icon]]:text-caution',
          error: '[&_[data-icon]]:text-destructive',
          info: '[&_[data-icon]]:text-primary',
        },
      }}
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
          '--border-radius': 'var(--radius-xl)',
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
